import { useCallback } from "react";
import { useNavigate } from "react-router";

import dayjs from "@/lib/dayjs";

import { TableCell, TableRow } from "@/components/ui/table/table";

import type { SearchResultTableRowData } from "../../../../model/type/view-data";

type Props = {
	row: SearchResultTableRowData;
};

const FORMAT_DATE_TEMPLATE = "YYYY年MM月DD日";

export const SearchResultTableTBody = ({ row }: Props) => {
	const {
		receiptID, //
		guestName,
		purchasedDate,
		totalGuestCharge,
		guestTel,
		guestEmail,
		purchasedItems,
	} = row;

	const totalGuestChargeText = `${totalGuestCharge.toLocaleString()}円`;

	const purchasedDateText = dayjs(purchasedDate).format(FORMAT_DATE_TEMPLATE);

	const navigate = useNavigate();
	const handleClickRow = useCallback(() => {
		navigate(row.detailPagePath);
	}, [navigate, row.detailPagePath]);

	return (
		<TableRow onClick={handleClickRow} className="cursor-pointer">
			<TableCell className="text-center">{receiptID}</TableCell>
			<TableCell className="text-center">{guestName}</TableCell>
			<TableCell className="text-center">{purchasedDateText}</TableCell>
			<TableCell className="text-center">{totalGuestChargeText}</TableCell>
			<TableCell className="text-center">{guestTel}</TableCell>
			<TableCell className="text-center">{guestEmail}</TableCell>
			<TableCell className="text-center">
				<div className="flex flex-col">
					{purchasedItems.map((item, idx) => {
						return (
							<p key={idx}>
								{item.name}({item.amount}個)
							</p>
						);
					})}
				</div>
			</TableCell>
		</TableRow>
	);
};
